export default "__VITE_ASSET__1cf9a598__"